export { default as ContactInfo } from './ContactInfo';



// WEBPACK FOOTER //
// ./src/components/Footer/ContactInfo/index.ts